// extracted by mini-css-extract-plugin
export default {"container":"Distance_container__1lcrh"};